import _typeof from "@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-finite.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import _ from 'lodash';
import { useShowDebugging, useVentureId } from '~/functions/accounts';
import { convertIntToUuid } from '~/functions/helpers';
import { formatCustomTargetWeightPercent } from '~/functions/impact-carry-kpi';
import { useMetricAssignmentFilterUrlSync } from '~/functions/metricAssignmentFilters';
import { hasQuarterlyOrMonthlyAnnualFallback, referencePeriodSlotKey, referencePeriodYear, sortReferencePeriods } from '~/functions/referencePeriods';
import { getLocale } from '~/functions/translate';
import { AccountCategory, MetricReportingPeriodType, MetricValueKind, MetricValueLockLevel, MetricValueLockOperation, MetricValueLockScope, MetricTheoryOfChangeRelation, useAddMetricAssignmentBatchMutation, useCanAssignmentBeDeletedLazyQuery, useGetAccountQuery, useGetUserQuery, useListMetricAssignmentsQuery, useUpdateMetricAssignmentMutation, useGetMetricAssignmentLazyQuery, useUpsertMetricValuesMutation, useListCategoriesQuery, useBatchLockMetricAssignmentValuesGranularMutation } from '~/types/types';

/** Last completed calendar quarter, API shape `YYYY Qn` (browser-local date). */

export default /*#__PURE__*/_defineComponent({
  __name: 'MetricAssignments',
  props: {
    height: {
      default: 'calc(100vh - 220px)',
      type: String
    },
    fixedHeader: {
      type: Boolean,
      default: function _default() {
        return false;
      },
      required: false
    },
    showSidebar: {
      default: false,
      type: Boolean
    },
    showGroupBy: {
      default: false,
      type: Boolean
    },
    showSearch: {
      default: false,
      type: Boolean
    },
    showCreation: {
      default: false,
      type: Boolean
    },
    showTop: {
      default: false,
      type: Boolean
    },
    headers: {
      required: false,
      type: Array,
      default: function _default() {
        return ['metric.name', 'unitName', 'comment', 'action'];
      }
    },
    commentHint: {
      require: false,
      type: String,
      default: ''
    },
    groupBy: {
      require: false,
      type: String,
      default: null
    },
    filters: {
      required: false,
      type: Object,
      default: function _default() {
        return {};
      }
    },
    itemsPerPage: {
      required: false,
      type: Number,
      default: function _default() {
        return -1;
      }
    },
    // When true, KPI creation is happening in the context
    // of Impact > Impact Carry > Measurement & KPIs and we
    // should treat the KPI as a Theory of Change KPI.
    isTocImpactCarryContext: {
      required: false,
      type: Boolean,
      default: false
    },
    // Optional override for the initially displayed reference periods.
    // When provided and non-empty, this takes precedence over account defaults.
    defaultPeriods: {
      required: false,
      type: Array,
      default: function _default() {
        return null;
      }
    },
    // When true, do not show any period/metricValues columns.
    hidePeriods: {
      required: false,
      type: Boolean,
      default: false
    },
    impactId: {
      required: false,
      type: Number,
      default: null
    },
    hideImpactKpis: {
      required: false,
      type: Boolean,
      default: false
    },
    // Keep pagination visible by pinning the table footer.
    // Intended for contexts where viewport height is constrained.
    pinPaginationFooter: {
      required: false,
      type: Boolean,
      default: false
    },
    initialEntryStatus: {
      required: false,
      type: String,
      default: 'all'
    },
    showOnlyEntryStatusToggle: {
      required: false,
      type: Boolean,
      default: false
    },
    emphasizedPeriods: {
      required: false,
      type: Array,
      default: function _default() {
        return [];
      }
    },
    applyInitialEntryStatusOnMountOnly: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  emits: ['data-loaded', 'metricValuesUpdated'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var slots = useSlots();
    var customAction = computed(function () {
      return !!slots.action;
    });
    var tableHeight = computed(function () {
      return props.pinPaginationFooter ? undefined : props.height;
    });
    var openedItem = ref(null);
    var openedChildId = ref(null);
    var openedChild = computed(function () {
      var _openedItem$value;
      if (!((_openedItem$value = openedItem.value) !== null && _openedItem$value !== void 0 && _openedItem$value.children) || !openedChildId.value) return null;
      return openedItem.value.children.find(function (child) {
        return child.id === openedChildId.value;
      }) || null;
    });
    var openedPeriod = ref('');
    var valueDialog = ref(false);
    var childrenDialog = ref(false);
    var selectedMetricAssignments = ref([]);
    var filteredCategoryIds = ref([]);
    var filteredSectionIds = ref([]);
    var showDebugging = useShowDebugging();
    var processedHeaders = computed(function () {
      var _account$value, _account$value2, _account$value3, _account$value4;
      var allHeaderByKey = {
        // expandToggle: {
        //   text: '',
        //   value: 'expandToggle',
        //   cellClass: '',
        //   width: '36px',
        //   sort: 0,
        //   sortable: false,
        // },
        id: {
          width: '20px',
          text: 'MAss ID',
          value: 'id',
          translatedText: 'ID',
          cellClass: ' font-weight-bold subtitle-2',
          sort: 2
        },
        'metric.id': {
          width: '10px',
          text: 'ID',
          value: 'metric.id',
          translatedText: 'KPI ID',
          cellClass: ' font-weight-bold subtitle-2',
          sort: 1
        },
        assigneeId: {
          width: '200px',
          value: 'assigneeId',
          translatedText: 'companyPerspective.kpis.headers.company',
          cellClass: 'text-center font-weight-bold subtitle-2',
          sort: 3
        },
        'metric.name': {
          width: '400px',
          text: 'KPI',
          value: 'metric.name',
          translatedText: 'companyPerspective.kpis.headers.kpi',
          cellClass: 'text-center font-weight-bold subtitle-2',
          sortable: true,
          sort: 4
        },
        'metric.commaSeparatedSections': {
          width: '290px',
          text: 'Related frameworks',
          value: 'metric.commaSeparatedSections',
          cellClass: '',
          sort: 5
        },
        'fund.name': {
          text: 'Fund',
          value: 'fund.name',
          cellClass: '',
          sort: 6
        },
        'metric.goalType': {
          text: 'Goal',
          value: 'metric.goalType',
          cellClass: '',
          sort: 7
        },
        'completionStatus.completionRate': {
          text: 'Target progress',
          value: 'completionStatus.completionRate',
          cellClass: 'text-center',
          width: '50px',
          sort: 8,
          sortable: false
        },
        impacts: {
          text: 'Impact',
          value: 'impacts',
          cellClass: 'text-center font-weight-bold subtitle-2',
          width: '200px',
          sort: 9
        },
        customTargetWeight: {
          width: '90px',
          text: 'Weight',
          value: 'customTargetWeight',
          cellClass: 'text-center',
          sort: 6
        },
        unitName: {
          width: '100px',
          text: 'Unit',
          value: 'unitName',
          cellClass: 'text-center',
          sort: 100
        },
        reportingPeriodType: {
          width: '150px',
          value: 'reportingPeriodType',
          cellClass: 'text-center font-weight-bold subtitle-2',
          sort: 101
        },
        action: {
          text: 'Actions',
          value: 'action',
          cellClass: 'align-middle subtitle-1 font-weight-bold',
          width: '100px',
          sort: 102
        },
        comment: {
          text: 'Comments',
          value: 'comment',
          width: '300px',
          cellClass: '',
          sort: 103
        }
      };
      var wantedHeaders = _toConsumableArray(props.headers).map(function (header) {
        return typeof header === 'string' ? {
          value: header
        } : header;
      });
      if (showDebugging.value) {
        wantedHeaders.unshift({
          value: 'id'
        });
      }
      wantedHeaders.unshift({
        value: 'metric.id'
      }); // released as new feature

      if (account !== null && account !== void 0 && (_account$value = account.value) !== null && _account$value !== void 0 && _account$value.reportingPeriodType && (account === null || account === void 0 ? void 0 : (_account$value2 = account.value) === null || _account$value2 === void 0 ? void 0 : _account$value2.reportingPeriodType) === MetricReportingPeriodType.Quarterly || account !== null && account !== void 0 && (_account$value3 = account.value) !== null && _account$value3 !== void 0 && _account$value3.portfolioLinks && (_account$value4 = account.value) !== null && _account$value4 !== void 0 && _account$value4.portfolioLinks.some(function (link) {
        var _link$portfolio;
        return ((_link$portfolio = link.portfolio) === null || _link$portfolio === void 0 ? void 0 : _link$portfolio.reportingPeriodType) === MetricReportingPeriodType.Quarterly;
      })) {
        wantedHeaders.unshift({
          value: 'reportingPeriodType'
        });
      }
      var x = wantedHeaders === null || wantedHeaders === void 0 ? void 0 : wantedHeaders.map(function (header) {
        if (header !== null && header !== void 0 && header.value) {
          return _objectSpread(_objectSpread({}, allHeaderByKey[header.value]), header);
        } else {
          if (!allHeaderByKey[header.value]) {
            console.error(header, 'does NOT exist!!!!!', header);
          }
          return allHeaderByKey[header.value];
        }
      });

      // Keep company -> KPI -> related frameworks order stable even when callers
      // pass custom header objects with their own sort values.
      var headerSortOrder = {
        assigneeId: 3,
        'metric.name': 4,
        'metric.commaSeparatedSections': 5
      };
      var _iterator = _createForOfIteratorHelper(x),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var header = _step.value;
          if (header !== null && header !== void 0 && header.value && Object.prototype.hasOwnProperty.call(headerSortOrder, header.value)) {
            header.sort = headerSortOrder[header.value];
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var periodSortOffset = 0;
      var quarterSubcolumnHeaderClass = 'align-center text-center grey lighten-5 grey--text text--lighten-1';
      var _iterator2 = _createForOfIteratorHelper(metricPeriodColumns.value || []),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var col = _step2.value;
          var isEmphasizedPeriod = emphasizedPeriods.value.has(col.metricValuePeriodKey);
          x.push(_objectSpread(_objectSpread({
            text: col.displayText,
            value: col.slotKey,
            cellClass: col.isPortfolioQuarterStatusOnly ? quarterSubcolumnHeaderClass : "align-center text-center ".concat(isEmphasizedPeriod ? 'primary--text font-weight-bold' : 'primary--text'),
            class: !col.isPortfolioQuarterStatusOnly && isEmphasizedPeriod ? 'metric-period-header--emphasized' : undefined
          }, col.isPortfolioQuarterStatusOnly ? {
            class: quarterSubcolumnHeaderClass
          } : {}), {}, {
            align: 'center',
            width: '75px',
            sortable: !col.isPortfolioQuarterStatusOnly,
            sort: 10 + periodSortOffset
          }));
          periodSortOffset++;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return x.sort(function (a, b) {
        if (a.sort < b.sort) return -1;
        if (a.sort > b.sort) return 1;
        return 0;
      });
    });
    var options = ref({
      page: 1,
      itemsPerPage: props.itemsPerPage,
      sortBy: ['metric.name'],
      sortDesc: [false]
    });
    var _useGetAccountQuery = useGetAccountQuery(),
      accountResult = _useGetAccountQuery.result;
    var account = computed(function () {
      var _accountResult$value;
      return (_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount;
    });
    var _useGetUserQuery = useGetUserQuery(),
      userResult = _useGetUserQuery.result;
    var user = computed(function () {
      var _userResult$value;
      return (_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : _userResult$value.getUser;
    });
    var canAccessKpiLocking = computed(function () {
      var _user$value, _account$value5;
      return showDebugging.value || ((_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.isAdmin) || ((_account$value5 = account.value) === null || _account$value5 === void 0 ? void 0 : _account$value5.type) === AccountCategory.Portfolio;
    });
    var kpiLockDialog = ref(false);
    var lockDialogItem = ref(null);
    var lockDialogItems = ref([]);
    var showSectionSidebar = computed(function () {
      var _account$value6, _user$value2;
      return ((_account$value6 = account.value) === null || _account$value6 === void 0 ? void 0 : _account$value6.type) === AccountCategory.Portfolio || ((_user$value2 = user.value) === null || _user$value2 === void 0 ? void 0 : _user$value2.isAdmin);
    });

    // On load we use default reference periods from account. But users can add more.
    var initialReferencePeriods = computed(function () {
      var _account$value7;
      // 0) Explicit disable
      if (props.hidePeriods) {
        return [];
      }

      // 1) Explicit override via props (used e.g. for impact carry & some tables)
      var override = props.defaultPeriods || null;
      if (override && override.length > 0) {
        return sortReferencePeriods(override);
      }

      // 2) Fallback to account / portfolio defaults
      var periods = [];
      if ((account === null || account === void 0 ? void 0 : (_account$value7 = account.value) === null || _account$value7 === void 0 ? void 0 : _account$value7.type) === AccountCategory.Portfolio) {
        var _account$value8, _account$value9;
        if (account !== null && account !== void 0 && (_account$value8 = account.value) !== null && _account$value8 !== void 0 && _account$value8.defaultReferencePeriods && (account === null || account === void 0 ? void 0 : (_account$value9 = account.value) === null || _account$value9 === void 0 ? void 0 : _account$value9.defaultReferencePeriods.length) > 0) {
          periods.push.apply(periods, _toConsumableArray(account.value.defaultReferencePeriods.map(String)));
        }
      } else {
        var _account$value10;
        // company, take set of portfolio settings
        var _iterator3 = _createForOfIteratorHelper((account === null || account === void 0 ? void 0 : (_account$value10 = account.value) === null || _account$value10 === void 0 ? void 0 : _account$value10.portfolioLinks) || []),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _link$portfolio2, _link$portfolio3;
            var link = _step3.value;
            if ((_link$portfolio2 = link.portfolio) !== null && _link$portfolio2 !== void 0 && _link$portfolio2.defaultReferencePeriods && ((_link$portfolio3 = link.portfolio) === null || _link$portfolio3 === void 0 ? void 0 : _link$portfolio3.defaultReferencePeriods.length) > 0) {
              periods.push.apply(periods, _toConsumableArray(link.portfolio.defaultReferencePeriods.map(String)));
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      if (periods.length === 0) {
        periods.push('2023', '2024');
      }
      return sortReferencePeriods(periods);
    });
    var displayedReferencePeriods = ref(initialReferencePeriods.value);
    var normalizedInitialEntryStatus = computed(function () {
      var value = String(props.initialEntryStatus || '');
      if (value === 'incomplete' || value === 'complete' || value === 'skipped') {
        return value;
      }
      return 'all';
    });
    var entryStatusFilter = ref(normalizedInitialEntryStatus.value);
    var buildCompletedPreviousCalendarQuarterPeriod = function buildCompletedPreviousCalendarQuarterPeriod() {
      var now = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
      var y = now.getFullYear();
      var m = now.getMonth();
      var calendarQuarter = Math.floor(m / 3) + 1;
      if (calendarQuarter === 1) {
        return "".concat(y - 1, " Q4");
      }
      return "".concat(y, " Q").concat(calendarQuarter - 1);
    };
    var quarterYearFromApiPeriod = function quarterYearFromApiPeriod(period) {
      return Number(period.split(' ', 1)[0]);
    };
    var usesPortfolioQuarterStatusColumn = computed(function () {
      if (props.hidePeriods) return false;
      var acct = account.value;
      if (!acct) return false;
      if (acct.type === AccountCategory.Portfolio) {
        return acct.reportingPeriodType === MetricReportingPeriodType.Quarterly;
      }
      return (acct.portfolioLinks || []).some(function (link) {
        var _link$portfolio4;
        return ((_link$portfolio4 = link.portfolio) === null || _link$portfolio4 === void 0 ? void 0 : _link$portfolio4.reportingPeriodType) === MetricReportingPeriodType.Quarterly;
      });
    });
    var portfolioQuarterStatusApiPeriod = computed(function () {
      if (!usesPortfolioQuarterStatusColumn.value) return null;
      return buildCompletedPreviousCalendarQuarterPeriod();
    });
    var metricPeriodColumns = computed(function () {
      var periods = sortReferencePeriods(displayedReferencePeriods.value || []);
      var cols = periods.map(function (period) {
        return {
          slotKey: referencePeriodSlotKey(period),
          displayText: period,
          metricValuePeriodKey: period,
          isPortfolioQuarterStatusOnly: false
        };
      });
      var q = portfolioQuarterStatusApiPeriod.value;
      if (!q) return cols;
      var qYear = quarterYearFromApiPeriod(q);
      if (!periods.some(function (period) {
        return referencePeriodYear(period) === qYear;
      })) return cols;
      if (cols.some(function (c) {
        return c.metricValuePeriodKey === q;
      })) return cols;
      var slotKey = referencePeriodSlotKey(q);
      cols.push({
        slotKey: slotKey,
        displayText: q,
        metricValuePeriodKey: q,
        isPortfolioQuarterStatusOnly: true
      });
      return cols;
    });
    var emphasizedPeriods = computed(function () {
      return new Set((props.emphasizedPeriods || []).map(function (p) {
        return String(p);
      }));
    });
    var latestStatusPeriod = computed(function () {
      var cols = metricPeriodColumns.value;
      if (!cols.length) return null;
      return cols[cols.length - 1].metricValuePeriodKey;
    });
    var internalFilters = ref(_objectSpread({
      isComputed: null,
      valueType: null,
      reportingPeriodType: [],
      hideImpactKpis: props.hideImpactKpis
    }, props.filters));
    var staticAssigneeIds = computed(function () {
      var _props$filters;
      return (_props$filters = props.filters) === null || _props$filters === void 0 ? void 0 : _props$filters.assigneeIds;
    });

    /** Selection universe for the company filter header select-all (portfolio ventures). */
    var allSelectableAssigneeIds = computed(function () {
      return staticAssigneeIds.value;
    });
    var _useMetricAssignmentF = useMetricAssignmentFilterUrlSync({
        entryStatusFilter: entryStatusFilter,
        defaultEntryStatus: normalizedInitialEntryStatus,
        applyDefaultStatusOnMountOnly: computed(function () {
          return props.applyInitialEntryStatusOnMountOnly;
        }),
        displayedReferencePeriods: displayedReferencePeriods,
        filteredCategoryIds: filteredCategoryIds,
        filteredSectionIds: filteredSectionIds,
        internalFilters: internalFilters,
        initialReferencePeriods: initialReferencePeriods,
        staticAssigneeIds: staticAssigneeIds,
        staticSectionIds: computed(function () {
          var _props$filters2;
          return (_props$filters2 = props.filters) === null || _props$filters2 === void 0 ? void 0 : _props$filters2.sectionIds;
        })
      }),
      applyFiltersFromRoute = _useMetricAssignmentF.applyFiltersFromRoute,
      hasRouteYearsFilter = _useMetricAssignmentF.hasRouteYearsFilter;
    watch([account, function () {
      return props.defaultPeriods;
    }], function () {
      if (hasRouteYearsFilter.value) return;
      displayedReferencePeriods.value = initialReferencePeriods.value;
    });
    watch(function () {
      return props.filters;
    }, function () {
      internalFilters.value = _objectSpread({
        isComputed: null,
        valueType: null,
        reportingPeriodType: []
      }, props.filters);
      applyFiltersFromRoute();
    });
    var variables = computed(function () {
      return {
        filters: _objectSpread(_objectSpread({}, internalFilters.value), {}, {
          sectionIds: (selectedSectionIdsForFilter.value.length > 0 ? selectedSectionIdsForFilter.value : internalFilters.value.sectionIds || []).map(function (id) {
            return Number(id);
          }).filter(function (id) {
            return Number.isFinite(id);
          }),
          categoryIds: selectedCategoryIdsForFilter.value,
          includeUncategorized: selectedIncludesUncategorized.value,
          statusPeriods: latestStatusPeriod.value === null ? [] : [String(latestStatusPeriod.value)],
          isDataEntered: null,
          isActualDataEntered: entryStatusFilter.value === 'complete' ? true : entryStatusFilter.value === 'incomplete' ? false : null,
          isSkipped: entryStatusFilter.value === 'skipped' ? true : entryStatusFilter.value === 'incomplete' ? false : null
        }),
        offset: options.value.itemsPerPage * (options.value.page - 1),
        limit: options.value.itemsPerPage,
        sort: options.value.sortBy.map(function (item, index) {
          return {
            field: String(item),
            sortDesc: options.value.sortDesc[index]
          };
        })
      };
    });
    var selectedCategoryIdsForFilter = computed(function () {
      return filteredCategoryIds.value.filter(function (id) {
        return id !== 'uncategorized';
      }).map(function (id) {
        return Number(id);
      }).filter(function (id) {
        return Number.isFinite(id);
      });
    });
    var selectedIncludesUncategorized = computed(function () {
      return filteredCategoryIds.value.includes('uncategorized');
    });
    var selectedSectionIdsForFilter = computed(function () {
      return filteredSectionIds.value.map(function (id) {
        return Number(id);
      }).filter(function (id) {
        return Number.isFinite(id);
      });
    });
    var categoryMapVariables = computed(function () {
      return {
        input: {
          onlyRootElements: true
        }
      };
    });
    var _useListCategoriesQue = useListCategoriesQuery(categoryMapVariables),
      categoriesResult = _useListCategoriesQue.result;
    var categoryLabelsById = computed(function () {
      var _categoriesResult$val;
      var labels = new Map();
      var _walk = function walk(category) {
        labels.set(String(category.id), category.label);
        if (Array.isArray(category.subcategories)) {
          category.subcategories.forEach(_walk);
        }
      };
      (((_categoriesResult$val = categoriesResult.value) === null || _categoriesResult$val === void 0 ? void 0 : _categoriesResult$val.listCategories) || []).forEach(_walk);
      return labels;
    });
    var _ref2 = getCurrentInstance(),
      proxy = _ref2.proxy;
    var selectedCategoryLabelText = computed(function () {
      var labels = filteredCategoryIds.value.map(function (id) {
        if (id === 'uncategorized') return proxy.$t('filteredFooter.uncategorized');
        return categoryLabelsById.value.get(String(id)) || String(id);
      }).filter(function (label) {
        return !!label;
      });
      if (labels.length <= 2) return labels.join(' & ');
      return "".concat(labels[0], ", ").concat(labels[1], "  ...");
    });
    var pageCount = computed(function () {
      var pageSize = Number(options.value.itemsPerPage || 0);
      if (pageSize <= 0) return 1;
      return Math.max(1, Math.ceil(itemCount.value / pageSize));
    });
    var hasStatusOrCategoryFilter = computed(function () {
      return filteredCategoryIds.value.length > 0 || entryStatusFilter.value !== 'all';
    });
    var showCategoryFilterFooterHint = computed(function () {
      return true;
    });
    var footerStatusText = computed(function () {
      if (entryStatusFilter.value === 'all') {
        return proxy.$t('filteredFooter.statusAll');
      }
      switch (entryStatusFilter.value) {
        case 'incomplete':
          return proxy.$t('entryStatus.incomplete');
        case 'complete':
          return proxy.$t('entryStatus.complete');
        case 'skipped':
          return proxy.$t('entryStatus.skipped');
        case 'all':
        default:
          return proxy.$t('filteredFooter.statusAll');
      }
    });
    var categoryFilterFooterText = computed(function () {
      return proxy.$t('filteredFooter.showing', {
        status: footerStatusText.value.toString().toLowerCase(),
        category: selectedCategoryLabelText.value ? " ".concat(selectedCategoryLabelText.value) : '',
        only: hasStatusOrCategoryFilter.value ? proxy.$t('filteredFooter.only') : '',
        page: options.value.page || 1,
        pages: pageCount.value
      });
    });
    var clearCategoryFilterText = computed(function () {
      return proxy.$t('filteredFooter.showAll');
    });
    var clearCategoryFilters = function clearCategoryFilters() {
      filteredCategoryIds.value = [];
      entryStatusFilter.value = 'all';
    };
    var hasExplicitEmptyAssigneeFilter = computed(function () {
      var scoped = staticAssigneeIds.value;
      if (!(scoped !== null && scoped !== void 0 && scoped.length)) return false;
      return !(internalFilters.value.assigneeIds || []).length;
    });
    var _useListMetricAssignm = useListMetricAssignmentsQuery(variables, computed(function () {
        return {
          fetchPolicy: 'cache-and-network',
          // Empty [] is ignored by the API assignee filter; skip the query so we
          // don't accidentally load unscoped assignments when the user cleared all.
          enabled: !hasExplicitEmptyAssigneeFilter.value
        };
      })),
      result = _useListMetricAssignm.result,
      refetch = _useListMetricAssignm.refetch,
      loading = _useListMetricAssignm.loading,
      error = _useListMetricAssignm.error;
    var refreshListMetricAssignments = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return refetch();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function refreshListMetricAssignments() {
        return _ref3.apply(this, arguments);
      };
    }();
    var queryErrorStatusCode = computed(function () {
      var _error$value, _networkError$respons;
      var networkError = (_error$value = error.value) === null || _error$value === void 0 ? void 0 : _error$value.networkError;
      if (!networkError) return null;
      return Number((networkError === null || networkError === void 0 ? void 0 : networkError.statusCode) || (networkError === null || networkError === void 0 ? void 0 : networkError.status) || (networkError === null || networkError === void 0 ? void 0 : (_networkError$respons = networkError.response) === null || _networkError$respons === void 0 ? void 0 : _networkError$respons.status)) || null;
    });
    var queryLoadErrorMessage = computed(function () {
      if (!error.value) return '';
      if (queryErrorStatusCode.value === 503 || queryErrorStatusCode.value === 504) {
        return proxy.$t('queryTimeout').toString();
      }
      return proxy.$t('queryError').toString();
    });
    var lastQueryErrorSignature = ref('');
    watch(error, function (nextError) {
      if (!nextError) {
        lastQueryErrorSignature.value = '';
        return;
      }
      var signature = "".concat(queryErrorStatusCode.value || 'unknown', "-").concat(nextError.message || 'error');
      if (signature === lastQueryErrorSignature.value) return;
      lastQueryErrorSignature.value = signature;
      window.$nuxt.$emit('userMsg', {
        message: queryLoadErrorMessage.value,
        color: 'error'
      });
    });
    var categoryCounts = computed(function () {
      var _result$value;
      return ((_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listMetricAssignmentCategoryCounts) || [];
    });
    var sectionCounts = computed(function () {
      var _result$value2;
      return ((_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.listMetricAssignmentSectionCounts) || [];
    });
    var _useGetMetricAssignme = useGetMetricAssignmentLazyQuery({
        id: 0
      }, {
        fetchPolicy: 'network-only'
      }),
      loadMetricAssignment = _useGetMetricAssignme.load,
      refetchMetricAssignment = _useGetMetricAssignme.refetch,
      loadingMetricAssignment = _useGetMetricAssignme.loading;
    var _useCanAssignmentBeDe = useCanAssignmentBeDeletedLazyQuery({
        id: 0
      }, {
        fetchPolicy: 'network-only'
      }),
      loadAssignmentDependencies = _useCanAssignmentBeDe.load,
      refetchAssignmentDependencies = _useCanAssignmentBeDe.refetch;
    var getAssignmentDependencies = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        var _result$data;
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return refetchAssignmentDependencies({
                id: id
              });
            case 2:
              _context2.t0 = _context2.sent;
              if (_context2.t0) {
                _context2.next = 7;
                break;
              }
              _context2.next = 6;
              return loadAssignmentDependencies({
                id: id
              });
            case 6:
              _context2.t0 = _context2.sent;
            case 7:
              result = _context2.t0;
              if (!(!result || _typeof(result) !== 'object')) {
                _context2.next = 10;
                break;
              }
              return _context2.abrupt("return", null);
            case 10:
              if (!('data' in result && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.canAssignmentBeDeleted)) {
                _context2.next = 12;
                break;
              }
              return _context2.abrupt("return", result.data.canAssignmentBeDeleted);
            case 12:
              if (!('canAssignmentBeDeleted' in result && result.canAssignmentBeDeleted)) {
                _context2.next = 14;
                break;
              }
              return _context2.abrupt("return", result.canAssignmentBeDeleted);
            case 14:
              return _context2.abrupt("return", null);
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function getAssignmentDependencies(_x) {
        return _ref4.apply(this, arguments);
      };
    }();
    var refreshComputedDependentsInBackground = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(assignmentId) {
        var _dependencies$computa, dependencies, dependentIds;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 100);
              });
            case 3:
              _context3.next = 5;
              return getAssignmentDependencies(assignmentId);
            case 5:
              dependencies = _context3.sent;
              dependentIds = (dependencies === null || dependencies === void 0 ? void 0 : (_dependencies$computa = dependencies.computationalDependentAssignments) === null || _dependencies$computa === void 0 ? void 0 : _dependencies$computa.map(function (assignment) {
                return Number(assignment === null || assignment === void 0 ? void 0 : assignment.id);
              }).filter(function (id) {
                return Number.isFinite(id);
              })) || [];
              if (dependentIds.length) {
                _context3.next = 9;
                break;
              }
              return _context3.abrupt("return");
            case 9:
              _context3.next = 11;
              return refreshListMetricAssignments();
            case 11:
              _context3.next = 16;
              break;
            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](0);
              // Best-effort background refresh; do not block the primary edit flow.
              console.error('Failed to refresh computed dependent metric assignments', _context3.t0);
            case 16:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 13]]);
      }));
      return function refreshComputedDependentsInBackground(_x2) {
        return _ref5.apply(this, arguments);
      };
    }();
    watch(result, function () {
      var _result$value3;
      // FIXME this is the only place we send API response back.
      emit('data-loaded', (_result$value3 = result.value) === null || _result$value3 === void 0 ? void 0 : _result$value3.listMetricAssignments);
    });
    var items = computed(function () {
      var _result$value4, _result$value4$listMe, _result$value4$listMe2;
      if (hasExplicitEmptyAssigneeFilter.value) return [];
      return ((_result$value4 = result.value) === null || _result$value4 === void 0 ? void 0 : (_result$value4$listMe = _result$value4.listMetricAssignments) === null || _result$value4$listMe === void 0 ? void 0 : (_result$value4$listMe2 = _result$value4$listMe.filter(function (e) {
        var _e$metric, _e$metric$sections;
        if ((_e$metric = e.metric) !== null && _e$metric !== void 0 && (_e$metric$sections = _e$metric.sections) !== null && _e$metric$sections !== void 0 && _e$metric$sections.some(function (s) {
          return s.id === 1801;
        })) {
          // 'To delete' section is hidden
          return false;
        }
        return true;
      })) === null || _result$value4$listMe2 === void 0 ? void 0 : _result$value4$listMe2.map(function (e) {
        return _objectSpread(_objectSpread({}, e), {}, {
          metricValuesByPeriod: Object.fromEntries((e.metricValues || []).map(function (e) {
            return [e.period, e];
          }))
        });
      }).sort(function (a, b) {
        if (props.groupBy) {
          var _$get;
          // FIXME v-data-table is buggy that we have to sort data by the groupping filed first!!!!!!!!
          return ((_$get = _.get(a, props.groupBy)) === null || _$get === void 0 ? void 0 : _$get.localeCompare(_.get(b, props.groupBy), undefined, {
            numeric: true
          })) || 0;
        }
        return 0;
      })) || [];
    });
    var itemCount = computed(function () {
      var _result$value$countMe, _result$value5;
      return hasExplicitEmptyAssigneeFilter.value ? 0 : (_result$value$countMe = (_result$value5 = result.value) === null || _result$value5 === void 0 ? void 0 : _result$value5.countMetricAssignments) !== null && _result$value$countMe !== void 0 ? _result$value$countMe : 0;
    });
    var _useUpdateMetricAssig = useUpdateMetricAssignmentMutation(),
      updateMetricAssignment = _useUpdateMetricAssig.mutate,
      onDone = _useUpdateMetricAssig.onDone;
    onDone(function () {
      window.$nuxt.$emit('userMsg');
    });
    var getChildIdByMetricId = function getChildIdByMetricId(children, metricId) {
      var child = children === null || children === void 0 ? void 0 : children.find(function (e) {
        var _e$metric2;
        return (e === null || e === void 0 ? void 0 : (_e$metric2 = e.metric) === null || _e$metric2 === void 0 ? void 0 : _e$metric2.id) === metricId;
      });
      return Number(child === null || child === void 0 ? void 0 : child.id) || null;
    };
    var _useAddMetricAssignme = useAddMetricAssignmentBatchMutation(),
      addMetricAssignmentBatch = _useAddMetricAssignme.mutate;
    var handleMetricValuesCreated = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(metricAssignmentId) {
        var sourceMetricAssignmentId, refreshed;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              sourceMetricAssignmentId = openedChildId.value || metricAssignmentId;
              _context4.prev = 1;
              _context4.next = 4;
              return refreshListMetricAssignments();
            case 4:
              refreshed = getLoadedMetricAssignmentById(metricAssignmentId);
              if (refreshed) {
                openedItem.value = JSON.parse(JSON.stringify(refreshed));
              }
              _context4.next = 11;
              break;
            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](1);
              console.error('Failed to refresh updated metric assignment', _context4.t0);
            case 11:
              void refreshComputedDependentsInBackground(sourceMetricAssignmentId);
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[1, 8]]);
      }));
      return function handleMetricValuesCreated(_x3) {
        return _ref6.apply(this, arguments);
      };
    }();
    var handleMetricAssignmentUpdated = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(payload) {
        var id, sourceMetricAssignmentId, refreshed;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              id = typeof payload === 'number' ? payload : payload.id;
              sourceMetricAssignmentId = openedChildId.value || id;
              _context5.prev = 2;
              _context5.next = 5;
              return refreshListMetricAssignments();
            case 5:
              refreshed = getLoadedMetricAssignmentById(id);
              if (refreshed) {
                openedItem.value = JSON.parse(JSON.stringify(refreshed));
              }
              _context5.next = 12;
              break;
            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](2);
              console.error('Failed to refresh updated metric assignment', _context5.t0);
            case 12:
              childrenDialog.value = false;
              void refreshComputedDependentsInBackground(sourceMetricAssignmentId);
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[2, 9]]);
      }));
      return function handleMetricAssignmentUpdated(_x4) {
        return _ref7.apply(this, arguments);
      };
    }();
    var getLoadedMetricAssignmentById = function getLoadedMetricAssignmentById(id) {
      var _result$value6;
      var assignments = ((_result$value6 = result.value) === null || _result$value6 === void 0 ? void 0 : _result$value6.listMetricAssignments) || [];
      return assignments.find(function (item) {
        return (item === null || item === void 0 ? void 0 : item.id) === id;
      }) || null;
    };
    var handleOpenByAssignmentId = function handleOpenByAssignmentId(id) {
      console.log('handleOpenByAssignmentId', id);
      childrenDialog.value = true;
      openedChildId.value = id;
    };
    var locale = computed(function () {
      return getLocale();
    });
    var missingChildMetricMsg = computed(function () {
      return locale.value === 'en' ? ' has not been assigned to this company.' : ' wurde dieser Firma nicht zugewiesen.';
    });
    var handleOpenByMetricId = function handleOpenByMetricId(id) {
      if (!openedItem.value) {
        return;
      }
      console.log('handleOpenByMetricId', id);
      childrenDialog.value = true;
      openedChildId.value = getChildIdByMetricId(openedItem.value.children || [], id);
      if (!openedChildId.value) {
        childrenDialog.value = false;
        window.$nuxt.$emit('userMsg', {
          message: 'KPI ' + id + missingChildMetricMsg.value,
          color: 'error'
        });
      }
    };
    var ventureId = useVentureId();
    var createMetricDialog = ref(false);
    var newMetricItem = ref({
      nameI18n: {},
      descriptionI18n: {},
      usageGuidanceI18n: {}
    });
    var editMetricDialog = ref(false);
    var editMetricItem = ref({
      nameI18n: {},
      descriptionI18n: {},
      usageGuidanceI18n: {}
    });
    var handleCreateMetricUpsert = function handleCreateMetricUpsert(metricId) {
      addMetricAssignmentBatch({
        inputs: [{
          metricId: metricId,
          assigneeId: ventureId.value,
          impactIds: props.impactId ? [props.impactId] : [],
          isFrozen: false
        }]
      }).then(function () {
        refetch();
      });
      createMetricDialog.value = false;
    };
    var canEditMetric = function canEditMetric(item) {
      var _account$value11, _account$value12;
      if (!(item !== null && item !== void 0 && item.metric)) return false;
      if (typeof item.metric.editable === 'boolean') return item.metric.editable;
      var metricOwnerId = item.metric.createdBy;
      var currentAccountId = (_account$value11 = account.value) === null || _account$value11 === void 0 ? void 0 : _account$value11.id;
      if (!metricOwnerId || !currentAccountId) return false;
      if (String(metricOwnerId) === String(currentAccountId)) return true;
      var linkedCompanyIds = (((_account$value12 = account.value) === null || _account$value12 === void 0 ? void 0 : _account$value12.ventureLinks) || []).map(function (link) {
        return String(link.ventureId);
      }).filter(Boolean);
      return linkedCompanyIds.includes(String(metricOwnerId));
    };
    var openEditMetricDialog = function openEditMetricDialog(item) {
      if (!(item !== null && item !== void 0 && item.metric) || !canEditMetric(item)) return;
      editMetricItem.value = structuredClone(item.metric);
      editMetricDialog.value = true;
    };
    var handleEditMetricUpsert = function handleEditMetricUpsert() {
      editMetricDialog.value = false;
      refetch();
    };
    var openLockDialog = function openLockDialog(item) {
      lockDialogItem.value = item;
      lockDialogItems.value = [item];
      kpiLockDialog.value = true;
    };
    var openBatchLockDialog = function openBatchLockDialog() {
      lockDialogItem.value = selectedMetricAssignments.value[0] || null;
      lockDialogItems.value = _toConsumableArray(selectedMetricAssignments.value);
      kpiLockDialog.value = true;
    };
    var _useBatchLockMetricAs = useBatchLockMetricAssignmentValuesGranularMutation(),
      batchLockAssignmentValuesGranular = _useBatchLockMetricAs.mutate;
    var submitLockAction = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(payload) {
        var _lockDialogItem$value, _data$batchLockMetric;
        var metricAssignmentIds, _yield$batchLockAssig, data, errors;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              metricAssignmentIds = payload.metricAssignmentIds.length ? payload.metricAssignmentIds : ((_lockDialogItem$value = lockDialogItem.value) === null || _lockDialogItem$value === void 0 ? void 0 : _lockDialogItem$value.id) != null ? [lockDialogItem.value.id] : [];
              if (metricAssignmentIds.length) {
                _context6.next = 3;
                break;
              }
              return _context6.abrupt("return");
            case 3:
              _context6.next = 5;
              return batchLockAssignmentValuesGranular({
                input: {
                  items: metricAssignmentIds.map(function (metricAssignmentId) {
                    return {
                      metricAssignmentId: metricAssignmentId,
                      periods: payload.years.map(String)
                    };
                  }),
                  operation: payload.operation === 'FREEZE' ? MetricValueLockOperation.Freeze : MetricValueLockOperation.Unfreeze,
                  scope: payload.scope === 'TARGET' ? MetricValueLockScope.Target : payload.scope === 'ACTUAL' ? MetricValueLockScope.Actual : MetricValueLockScope.TargetAndActual,
                  lockingLevel: payload.level === 'PORTFOLIO' ? MetricValueLockLevel.Portfolio : MetricValueLockLevel.IxAdmin,
                  reason: payload.reason
                }
              });
            case 5:
              _yield$batchLockAssig = _context6.sent;
              data = _yield$batchLockAssig.data;
              errors = (data === null || data === void 0 ? void 0 : (_data$batchLockMetric = data.batchLockMetricAssignmentValuesGranular) === null || _data$batchLockMetric === void 0 ? void 0 : _data$batchLockMetric.errors) || [];
              if (errors.length) {
                window.$nuxt.$emit('userMsg', {
                  color: 'error',
                  message: errors.map(function (error) {
                    return "#".concat(error.metricAssignmentId, ": ").concat(error.message);
                  }).join(' | ')
                });
              }
              _context6.next = 11;
              return refetch();
            case 11:
              if (payload.operation === MetricValueLockOperation.Unfreeze) {
                kpiLockDialog.value = false;
                lockDialogItem.value = null;
                lockDialogItems.value = [];
                selectedMetricAssignments.value = [];
              }
              window.$nuxt.$emit('userMsg');
            case 13:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function submitLockAction(_x5) {
        return _ref8.apply(this, arguments);
      };
    }();
    var isCustomTargetSupported = function isCustomTargetSupported(item) {
      var _item$metric;
      var valueType = item === null || item === void 0 ? void 0 : (_item$metric = item.metric) === null || _item$metric === void 0 ? void 0 : _item$metric.valueType;
      return ![MetricValueKind.String, MetricValueKind.Select, MetricValueKind.SingleSelect].includes(valueType);
    };
    var formatTocRelationLabel = function formatTocRelationLabel(relation) {
      if (!relation) return '';
      switch (relation) {
        case MetricTheoryOfChangeRelation.SolutionsOutput:
          return 'Solutions (Output)';
        case MetricTheoryOfChangeRelation.Outcome:
          return 'Outcome';
        case MetricTheoryOfChangeRelation.ImpactLongTerm:
          return 'Impact';
        default:
          return '';
      }
    };
    var hasActualLikeValue = function hasActualLikeValue(metricValue) {
      var _metricValue$options;
      return !!metricValue && (metricValue.actual !== null && metricValue.actual !== undefined || metricValue.text !== null && metricValue.text !== undefined && metricValue.text !== '' || (((_metricValue$options = metricValue.options) === null || _metricValue$options === void 0 ? void 0 : _metricValue$options.length) || 0) > 0);
    };

    /** Read-only portfolio quarter sub-column: show value only when assignment is sub-annual and MV has data/skip. */
    var portfolioQuarterSubcolumnHasDisplayValue = function portfolioQuarterSubcolumnHasDisplayValue(item, periodKey) {
      var _item$metricValuesByP;
      if (item.reportingPeriodType === MetricReportingPeriodType.Annual) {
        return false;
      }
      var mv = (_item$metricValuesByP = item.metricValuesByPeriod) === null || _item$metricValuesByP === void 0 ? void 0 : _item$metricValuesByP[periodKey];
      if (!mv || Object.keys(mv).length === 0) return false;
      return !!(mv.skipped || hasActualLikeValue(mv));
    };
    var getStatusPeriodWithFallback = function getStatusPeriodWithFallback(period, statuses) {
      if (!period) return null;
      var exact = statuses.find(function (status) {
        return (status === null || status === void 0 ? void 0 : status.period) === period;
      }) || null;
      if (exact) return exact;
      if (!period.includes(' ') || !hasQuarterlyOrMonthlyAnnualFallback(period)) {
        return null;
      }
      var annualPeriod = period.split(' ', 1)[0];
      return statuses.find(function (status) {
        return (status === null || status === void 0 ? void 0 : status.period) === annualPeriod;
      }) || null;
    };
    var getMetricValueWithFallback = function getMetricValueWithFallback(period, values) {
      if (!period) return null;
      var exact = values.find(function (value) {
        return (value === null || value === void 0 ? void 0 : value.period) === period;
      }) || null;
      if (exact && (exact.skipped || hasActualLikeValue(exact))) {
        return exact;
      }
      if (!period.includes(' ') || !hasQuarterlyOrMonthlyAnnualFallback(period)) {
        return exact;
      }
      var annualPeriod = period.split(' ', 1)[0];
      return values.find(function (value) {
        return (value === null || value === void 0 ? void 0 : value.period) === annualPeriod;
      }) || null;
    };
    var entryStatusKey = function entryStatusKey(item) {
      var latestDisplayedPeriod = latestStatusPeriod.value === null ? null : String(latestStatusPeriod.value);
      var periodStatuses = item.periodStatuses || [];
      var selectedStatus = getStatusPeriodWithFallback(latestDisplayedPeriod, periodStatuses);
      if (selectedStatus !== null && selectedStatus !== void 0 && selectedStatus.isSkipped) {
        return 'skipped';
      }
      if (selectedStatus !== null && selectedStatus !== void 0 && selectedStatus.isActualDataEntered) {
        return 'complete';
      }

      // Guard against stale period-status rows by checking metric values with
      // the same quarterly->annual fallback rule used by backend filtering.
      var metricValues = item.metricValues || [];
      var selectedMetricValue = getMetricValueWithFallback(latestDisplayedPeriod, metricValues);
      if (selectedMetricValue !== null && selectedMetricValue !== void 0 && selectedMetricValue.skipped) {
        return 'skipped';
      }
      if (hasActualLikeValue(selectedMetricValue)) {
        return 'complete';
      }
      return 'incomplete';
    };
    var entryStatusChipColor = function entryStatusChipColor(item) {
      var status = entryStatusKey(item);
      if (status === 'complete') return 'green lighten-4';
      if (status === 'skipped') return 'orange lighten-4';
      return 'red lighten-4';
    };
    var entryStatusChipTextColor = function entryStatusChipTextColor(item) {
      var status = entryStatusKey(item);
      if (status === 'complete') return 'green darken-2';
      if (status === 'skipped') return 'orange darken-3';
      return 'red darken-3';
    };
    var hasCopyFeature = computed(function () {
      return displayedReferencePeriods.value.length >= 2;
    });
    var sortedDisplayedReferencePeriods = computed(function () {
      return sortReferencePeriods(displayedReferencePeriods.value || []);
    });
    var copySourcePeriod = computed(function () {
      var periods = sortedDisplayedReferencePeriods.value;
      if (!periods || periods.length < 2) return null;
      return periods[periods.length - 2];
    });
    var copyDestPeriod = computed(function () {
      var periods = sortedDisplayedReferencePeriods.value;
      if (!periods || periods.length < 2) return null;
      return periods[periods.length - 1];
    });
    var hasCopyableSourceValue = function hasCopyableSourceValue(mv) {
      var _mv$options;
      if (!mv) return false;
      if (mv.actual !== null && mv.actual !== undefined) return true;
      if (mv.text !== null && mv.text !== undefined && mv.text !== '') return true;
      if ((((_mv$options = mv.options) === null || _mv$options === void 0 ? void 0 : _mv$options.length) || 0) > 0) return true;
      return false;
    };
    var hasAnyEnteredValue = function hasAnyEnteredValue(mv) {
      var _mv$options2;
      if (!mv) return false;
      if (mv.comment !== null && mv.comment !== undefined && mv.comment !== '') return true;
      if (mv.skipped) return true;
      if (mv.actual !== null && mv.actual !== undefined) return true;
      if (mv.text !== null && mv.text !== undefined && mv.text !== '') return true;
      if ((((_mv$options2 = mv.options) === null || _mv$options2 === void 0 ? void 0 : _mv$options2.length) || 0) > 0) return true;
      return false;
    };
    var canEditCopyDestination = function canEditCopyDestination(mv) {
      var _user$value3;
      // Mirror the value dialog guard: non-admin users cannot edit locked values,
      // and any explicit non-editable flag should block writes.
      if ((mv === null || mv === void 0 ? void 0 : mv.editable) === false) return false;
      if (!((_user$value3 = user.value) !== null && _user$value3 !== void 0 && _user$value3.isAdmin) && mv !== null && mv !== void 0 && mv.actualLocked) return false;
      return true;
    };
    var canCopyPreviousForRow = function canCopyPreviousForRow(item) {
      var _item$metric2;
      if (!hasCopyFeature.value) return false;
      if (item.reportingPeriodType !== MetricReportingPeriodType.Annual) {
        return false;
      }
      var srcPeriod = copySourcePeriod.value;
      var destPeriod = copyDestPeriod.value;
      if (!srcPeriod || !destPeriod || !item.metricValuesByPeriod) return false;

      // Respect read-only/computed/frozen assignments
      if ((_item$metric2 = item.metric) !== null && _item$metric2 !== void 0 && _item$metric2.isComputed) return false;
      var src = item.metricValuesByPeriod[srcPeriod];
      var dest = item.metricValuesByPeriod[destPeriod];
      return canEditCopyDestination(dest) && hasCopyableSourceValue(src) && !hasAnyEnteredValue(dest);
    };
    var buildCopyInput = function buildCopyInput(item, sourcePeriod, destPeriod) {
      var _src$actual, _src$text, _src$options;
      var src = item.metricValuesByPeriod[sourcePeriod];
      if (!src) return null;
      return {
        metricAssignmentId: item.id,
        period: destPeriod,
        actual: (_src$actual = src.actual) !== null && _src$actual !== void 0 ? _src$actual : null,
        text: (_src$text = src.text) !== null && _src$text !== void 0 ? _src$text : null,
        options: (_src$options = src.options) !== null && _src$options !== void 0 ? _src$options : null,
        comment: null,
        target: null,
        skipped: false
      };
    };
    var _useUpsertMetricValue = useUpsertMetricValuesMutation(),
      upsertMetricValues = _useUpsertMetricValue.mutate;
    var copyPreviousYearValue = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(item) {
        var _result$data2, _result$data2$upsertM;
        var srcPeriod, destPeriod, input, result;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              srcPeriod = copySourcePeriod.value;
              destPeriod = copyDestPeriod.value;
              if (!(!srcPeriod || !destPeriod)) {
                _context7.next = 4;
                break;
              }
              return _context7.abrupt("return");
            case 4:
              input = buildCopyInput(item, srcPeriod, destPeriod);
              if (input) {
                _context7.next = 7;
                break;
              }
              return _context7.abrupt("return");
            case 7:
              _context7.next = 9;
              return upsertMetricValues({
                inputs: [input]
              });
            case 9:
              result = _context7.sent;
              if (!(result !== null && result !== void 0 && (_result$data2 = result.data) !== null && _result$data2 !== void 0 && (_result$data2$upsertM = _result$data2.upsertMetricValues) !== null && _result$data2$upsertM !== void 0 && _result$data2$upsertM.length)) {
                _context7.next = 13;
                break;
              }
              _context7.next = 13;
              return handleMetricAssignmentUpdated({
                id: item.id,
                updatedValues: [input]
              });
            case 13:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return function copyPreviousYearValue(_x6) {
        return _ref9.apply(this, arguments);
      };
    }();
    var getItemClass = function getItemClass(item) {
      var _item$metric3;
      return item !== null && item !== void 0 && (_item$metric3 = item.metric) !== null && _item$metric3 !== void 0 && _item$metric3.isComputed ? 'kpi-row-computed' : '';
    };
    return {
      __sfc: true,
      props: props,
      emit: emit,
      slots: slots,
      customAction: customAction,
      tableHeight: tableHeight,
      openedItem: openedItem,
      openedChildId: openedChildId,
      openedChild: openedChild,
      openedPeriod: openedPeriod,
      valueDialog: valueDialog,
      childrenDialog: childrenDialog,
      selectedMetricAssignments: selectedMetricAssignments,
      filteredCategoryIds: filteredCategoryIds,
      filteredSectionIds: filteredSectionIds,
      showDebugging: showDebugging,
      processedHeaders: processedHeaders,
      options: options,
      accountResult: accountResult,
      account: account,
      userResult: userResult,
      user: user,
      canAccessKpiLocking: canAccessKpiLocking,
      kpiLockDialog: kpiLockDialog,
      lockDialogItem: lockDialogItem,
      lockDialogItems: lockDialogItems,
      showSectionSidebar: showSectionSidebar,
      initialReferencePeriods: initialReferencePeriods,
      displayedReferencePeriods: displayedReferencePeriods,
      normalizedInitialEntryStatus: normalizedInitialEntryStatus,
      entryStatusFilter: entryStatusFilter,
      buildCompletedPreviousCalendarQuarterPeriod: buildCompletedPreviousCalendarQuarterPeriod,
      quarterYearFromApiPeriod: quarterYearFromApiPeriod,
      usesPortfolioQuarterStatusColumn: usesPortfolioQuarterStatusColumn,
      portfolioQuarterStatusApiPeriod: portfolioQuarterStatusApiPeriod,
      metricPeriodColumns: metricPeriodColumns,
      emphasizedPeriods: emphasizedPeriods,
      latestStatusPeriod: latestStatusPeriod,
      internalFilters: internalFilters,
      staticAssigneeIds: staticAssigneeIds,
      allSelectableAssigneeIds: allSelectableAssigneeIds,
      applyFiltersFromRoute: applyFiltersFromRoute,
      hasRouteYearsFilter: hasRouteYearsFilter,
      variables: variables,
      selectedCategoryIdsForFilter: selectedCategoryIdsForFilter,
      selectedIncludesUncategorized: selectedIncludesUncategorized,
      selectedSectionIdsForFilter: selectedSectionIdsForFilter,
      categoryMapVariables: categoryMapVariables,
      categoriesResult: categoriesResult,
      categoryLabelsById: categoryLabelsById,
      proxy: proxy,
      selectedCategoryLabelText: selectedCategoryLabelText,
      pageCount: pageCount,
      hasStatusOrCategoryFilter: hasStatusOrCategoryFilter,
      showCategoryFilterFooterHint: showCategoryFilterFooterHint,
      footerStatusText: footerStatusText,
      categoryFilterFooterText: categoryFilterFooterText,
      clearCategoryFilterText: clearCategoryFilterText,
      clearCategoryFilters: clearCategoryFilters,
      hasExplicitEmptyAssigneeFilter: hasExplicitEmptyAssigneeFilter,
      result: result,
      refetch: refetch,
      loading: loading,
      error: error,
      refreshListMetricAssignments: refreshListMetricAssignments,
      queryErrorStatusCode: queryErrorStatusCode,
      queryLoadErrorMessage: queryLoadErrorMessage,
      lastQueryErrorSignature: lastQueryErrorSignature,
      categoryCounts: categoryCounts,
      sectionCounts: sectionCounts,
      loadMetricAssignment: loadMetricAssignment,
      refetchMetricAssignment: refetchMetricAssignment,
      loadingMetricAssignment: loadingMetricAssignment,
      loadAssignmentDependencies: loadAssignmentDependencies,
      refetchAssignmentDependencies: refetchAssignmentDependencies,
      getAssignmentDependencies: getAssignmentDependencies,
      refreshComputedDependentsInBackground: refreshComputedDependentsInBackground,
      items: items,
      itemCount: itemCount,
      updateMetricAssignment: updateMetricAssignment,
      onDone: onDone,
      getChildIdByMetricId: getChildIdByMetricId,
      addMetricAssignmentBatch: addMetricAssignmentBatch,
      handleMetricValuesCreated: handleMetricValuesCreated,
      handleMetricAssignmentUpdated: handleMetricAssignmentUpdated,
      getLoadedMetricAssignmentById: getLoadedMetricAssignmentById,
      handleOpenByAssignmentId: handleOpenByAssignmentId,
      locale: locale,
      missingChildMetricMsg: missingChildMetricMsg,
      handleOpenByMetricId: handleOpenByMetricId,
      ventureId: ventureId,
      createMetricDialog: createMetricDialog,
      newMetricItem: newMetricItem,
      editMetricDialog: editMetricDialog,
      editMetricItem: editMetricItem,
      handleCreateMetricUpsert: handleCreateMetricUpsert,
      canEditMetric: canEditMetric,
      openEditMetricDialog: openEditMetricDialog,
      handleEditMetricUpsert: handleEditMetricUpsert,
      openLockDialog: openLockDialog,
      openBatchLockDialog: openBatchLockDialog,
      batchLockAssignmentValuesGranular: batchLockAssignmentValuesGranular,
      submitLockAction: submitLockAction,
      isCustomTargetSupported: isCustomTargetSupported,
      formatTocRelationLabel: formatTocRelationLabel,
      hasActualLikeValue: hasActualLikeValue,
      portfolioQuarterSubcolumnHasDisplayValue: portfolioQuarterSubcolumnHasDisplayValue,
      getStatusPeriodWithFallback: getStatusPeriodWithFallback,
      getMetricValueWithFallback: getMetricValueWithFallback,
      entryStatusKey: entryStatusKey,
      entryStatusChipColor: entryStatusChipColor,
      entryStatusChipTextColor: entryStatusChipTextColor,
      hasCopyFeature: hasCopyFeature,
      sortedDisplayedReferencePeriods: sortedDisplayedReferencePeriods,
      copySourcePeriod: copySourcePeriod,
      copyDestPeriod: copyDestPeriod,
      hasCopyableSourceValue: hasCopyableSourceValue,
      hasAnyEnteredValue: hasAnyEnteredValue,
      canEditCopyDestination: canEditCopyDestination,
      canCopyPreviousForRow: canCopyPreviousForRow,
      buildCopyInput: buildCopyInput,
      upsertMetricValues: upsertMetricValues,
      copyPreviousYearValue: copyPreviousYearValue,
      getItemClass: getItemClass,
      convertIntToUuid: convertIntToUuid,
      formatCustomTargetWeightPercent: formatCustomTargetWeightPercent,
      MetricReportingPeriodType: MetricReportingPeriodType,
      MetricValueKind: MetricValueKind
    };
  }
});